module.exports = __webpack_public_path__ + "assets/img/Type E (32).ef8fc440.jpg";